import {RatingReviewMediaType} from "../../definitions/types";

export class RatingReviewMediaModel {
    private readonly _id: number;
    private readonly _ratingId: number;
    private readonly _reviewId: number;
    private readonly _filename: string;
    private readonly _url: string;
    private readonly _width?: number;
    private readonly _height?: number;
    private readonly _visible: boolean;
    private readonly _createdOn: Date;
    private readonly _updatedOn?: Date;

    constructor(public readonly ratingReviewMediaType: RatingReviewMediaType) {
        this._id = ratingReviewMediaType.id;
        this._ratingId = ratingReviewMediaType.ratingId;
        this._reviewId = ratingReviewMediaType.reviewId;
        this._filename = ratingReviewMediaType.filename;
        this._url = ratingReviewMediaType.url;
        this._width = ratingReviewMediaType.width;
        this._height = ratingReviewMediaType.height;
        this._visible = ratingReviewMediaType.visible;
        this._createdOn = ratingReviewMediaType.created;
        this._updatedOn = ratingReviewMediaType.updated;
    }

    /**
     * @method id
     * @description Returns the id of the media for the review medium.
     * @returns {number}
     */
    public get id(): number {
        return this._id;
    }

    /**
     * @method ratingId
     * @description Returns the id of the rating for the review medium.
     * @returns {number}
     */
    public get ratingId(): number {
        return this._ratingId;
    }

    /**
     * @method reviewId
     * @description Returns the id of the review for the review medium.
     * @returns {number}
     */
    public get reviewId(): number {
        return this._reviewId;
    }

    /**
     * @method filename
     * @description Returns the filename of the review medium.
     * @returns {string}
     */

    public get filename(): string {
        return this._filename;
    }

    /**
     * @method url
     * @description Returns the url of the review medium.
     * @returns {string}
     */
    public get url(): string {
        return this._url;
    }

    /**
     * @method width
     * @description Returns the width of the review medium.
     * @returns {number | undefined}
     */
    public get width(): number | undefined {
        return this._width;
    }

    /**
     * @method height
     * @description Returns the height of the review medium.
     * @returns {number | undefined}
     */
    public get height(): number | undefined {
        return this._height;
    }

    /**
     * @method visible
     * @description Returns the visibility of the review medium.
     * @returns {boolean}
     */
    public get visible(): boolean {
        return this._visible;
    }

    /**
     * @method createdOn
     * @description Returns the date the review medium was created.
     * @returns {Date}
     */
    public get createdOn(): Date {
        return this._createdOn;
    }

    /**
     * @method updatedOn
     * @description Returns the date the review medium was updated.
     * @returns {Date | undefined}
     */
    public get updatedOn(): Date | undefined {
        return this._updatedOn;
    }
}